import { useContentContext } from '@context/content';
import { Plan } from 'types/plan.types';
import { Offer } from 'types/offer.types';
import { StoryData } from 'storyblok-js-client';

export const usePlanData = () => {
  const { plan, planContent, offer, offerContent } = useContentContext();

  return { plan, planContent, offer, offerContent } as {
    plan: Plan;
    offer: Offer;
    planContent: any;
    offerContent: StoryData;
  };
};
